
// let BASE_API = 'http://localhost:8080/api/'
let BASE_API = 'https://terminmasterapi.in.rs/api/'

export default BASE_API


// WEBPACK FOOTER //
// ./src/services/BaseApi.js